import type { SystemConfig } from "@chakra-ui/react";

import addressEntity from "./globals/address-entity";
import entity from "./globals/entity";
import recaptcha from "./globals/recaptcha";
import scrollbar from "./globals/scrollbar";

const webkitAutofillOverrides = {
  WebkitTextFillColor: "var(--chakra-colors-input-fg)",
  WebkitBoxShadow: "0 0 0px 1000px var(--chakra-colors-input-bg) inset",
  transition: "background-color 5000s ease-in-out 0s",
};

const webkitAutofillRules = {
  "&:-webkit-autofill": webkitAutofillOverrides,
  "&:-webkit-autofill:hover": webkitAutofillOverrides,
  "&:-webkit-autofill:focus": webkitAutofillOverrides,
};

const globalCss: SystemConfig["globalCss"] = {
  body: {
    bg: "global.body.bg",
    color: "global.body.fg",
    WebkitTapHighlightColor: "transparent",
    fontVariantLigatures: "no-contextual",
    focusRingStyle: "hidden",
  },
  mark: {
    bg: "global.mark.bg",
    color: "inherit",
  },
  "svg *::selection": {
    color: "none",
    background: "none",
  },
  form: {
    w: "100%",
  },
  input: {
    // hide number input arrows in Google Chrome
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
    ...webkitAutofillRules,
  },
  textarea: {
    ...webkitAutofillRules,
  },
  select: {
    ...webkitAutofillRules,
  },
  ...recaptcha,
  ...scrollbar,
  ...entity,
  ...addressEntity,
};

export default globalCss;
